import { AppPhase, DealingSubPhase } from '../../models/communication/app-enums.model';
import { CardDealtEvent } from '../../models/communication/app-events.model';
import { GameBase } from '../game-base';
import { GameFlowBase } from '../game-flow-base';
import { ThreeHeadedDragonCardPosition } from '../main-games/three-headed-dragon/three-headed-dragon.model';
import { CardState, HandState } from '../models/game-view.model';

const states = ['START', 'FACE-UP-CARD', 'CHECK-TIGER', 'SHOW-TIGER', 'OUTCOME'] as const;

export class ThreeHeadedDragonFlow extends GameFlowBase<GameBase, (typeof states)[number]> {
    protected override states = states;

    override onChanges(table?: CardDealtEvent, _subPhase?: DealingSubPhase, appPhase?: AppPhase): void {
        switch (this.getState()) {
            case 'START': {
                this.game.updateHands(HandState.Muted);
                this.game.faceUpMessage(this.game.getFirstCardPosition());
                this.nextState();
                break;
            }

            case 'FACE-UP-CARD': {
                if (!table) return;

                this.game.revealCard(table.cardPosition, table.card);

                if (table.nextCardPosition === ThreeHeadedDragonCardPosition.TigerCard) {
                    this.game.faceDownMessage(table.nextCardPosition);
                    this.nextState();
                    return;
                }

                if (table.nextCardPosition !== undefined) {
                    this.game.faceUpMessage(table.nextCardPosition);
                }

                break;
            }

            case 'CHECK-TIGER': {
                if (!table) return;

                this.game.updateHands(HandState.Default);
                this.game.updateCard(table.cardPosition, CardState.Checked);
                this.game.allCardsDrawn();
                this.nextState();
                break;
            }

            case 'SHOW-TIGER': {
                if (appPhase === AppPhase.Decision) {
                    this.game.playerDecisionTime();
                    return;
                }

                if (!table) return;

                if (table.cardPosition === ThreeHeadedDragonCardPosition.TigerCard) {
                    this.game.revealCard(table.cardPosition, table.card);
                }

                if (table.nextCardPosition === undefined) {
                    this.nextState();
                }
                break;
            }

            case 'OUTCOME': {
                if (!table) return;

                if (table.outcome !== undefined && table.outcomes !== undefined) {
                    this.game.handleOutcome(table);
                }
            }
        }
    }
}
